// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faTs = {
  prefix: "fak",
  iconName: "ts",
  icon: [
    512,
    512,
    [],
    "e006",
    "M0 256v256h512V0H0zm412.6-20.4c13 3.2 22.9 9.1 32.1 18.5c4.7 5 11.7 14.2 12.3 16.4c.2 .7-22.1 15.6-35.6 23.9c-.5 .3-2.5-1.7-4.7-5c-6.6-9.6-13.5-13.7-24.1-14.5c-15.5-1-25.5 7.1-25.4 20.7c-.1 3.3 .7 6.7 2.2 9.6c3.4 7.1 9.8 11.3 29.7 19.9c36.7 15.7 52.3 26.2 62.1 40.9c10.9 16.5 13.3 42.8 6 62.5c-8.2 21.2-28.3 35.7-56.7 40.5c-8.8 1.6-29.6 1.3-39-.4c-20.6-3.7-40.1-13.8-52.1-27.2c-4.8-5.2-13.9-18.8-13.3-19.7c.3-.3 2.3-1.7 4.7-3s10.9-6.3 19-11l14.8-8.6 3.1 4.6c4.3 6.6 13.7 15.6 19.4 18.6c16.3 8.7 38.8 7.4 49.8-2.5c4.5-3.7 7-9.5 6.7-15.3c0-5.9-.8-8.6-3.8-13c-4-5.7-12.1-10.5-35.2-20.5c-26.4-11.4-37.8-18.4-48.2-29.7c-6.5-7.4-11.3-16.2-14.1-25.6c-1.9-7.2-2.4-25.4-.9-32.7c5.4-25.6 24.8-43.3 52.5-48.6c9-1.7 30-1.1 38.8 1.1zM292.4 257l.2 20.9h-66.7v189.4h-47.2V277.9h-66.6v-20.5c0-11.4 .3-20.9 .6-21.2c.3-.3 40.8-.5 89.9-.4l89.5 .3z"
  ]
};
export {
  faTs
};
